import { CampaignAnalytics } from '../../components/analytics/CampaignAnalytics';

/**
 * Post-creation Overview tab. The analytics page is now data-driven (it adapts
 * to campaign type, senders and agentic config), so both campaign types render
 * the same shared component.
 */
export const UnifiedAnalytics = () => <CampaignAnalytics />;
